import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/services/guards/auth.guard';
import { ROUTER_CONFIG } from '@core/utils/configs';

const routes: Routes = [
  {
    path: 'auth',
    //canActivate: [NoAuthGuard],
    loadChildren: () => import('@pages/auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'terminos-y-condiciones',
    loadChildren: () => import('@pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule)
  },
  {
    path: 'app',
    canActivate: [AuthGuard],
    loadChildren: () => import('@pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, ROUTER_CONFIG)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
